import * as Icon from "@ant-design/icons";
import { Row, Form, Col, Modal, Flex } from "antd";
import { ColumnsType } from "antd/es/table";
import Search from "antd/lib/input/Search";
import { useEffect } from "react";
import { TipoTaxaImpostoModel } from "../../models/tipoTaxaImposto/tipoTaxaImpostoModel";
import { setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import { setEntityTipoTaxaImposto, setBuscaTipoTaxaImposto, setModalCadastrarTipoTaxaImposto, setModalDeletarTipoTaxaImposto } from "../../redux/slices/tipoTaxaImposto/tipoTaxaImpostoSlice";
import { buscarTipoTaxaImposto, deletarTipoTaxaImposto } from "../../services/tipoTaxaImpostoService";
import { useAppSelector, useAppDispatch } from "../../util/hooks";
import CadastroTipoTaxaImposto from "./modals/cadastrar";
import { ItemMenuAcoes } from "../../models/sistema/itemMenuAcoes";
import AcoesComponent from "../../components/table/acoesComponent";
import { ButtonComponent } from "../../components/button/cadastrar";
import MensagemModal from "../../components/modal/mensagem";
import TableComponent from "../../components/table/tableComponent";

const TipoTaxaImposto = () => {
  //estados globais
  const tipoTaxaImpostoState = useAppSelector((state) => state.tipoTaxaImposto);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais

  const editar = Object.values(tipoTaxaImpostoState.entity).length !== 0;

  useEffect(() => {
    dispatch(setTitle("TIPOS DE IMPOSTOS"));
    dispatch(buscarTipoTaxaImposto(tipoTaxaImpostoState.busca));
  }, []);

  const goCadastrar = () => {
    dispatch(setEntityTipoTaxaImposto({}));
    dispatch(setModalCadastrarTipoTaxaImposto(true));
  };

  const goEditar = (value: TipoTaxaImpostoModel) => {
    dispatch(setEntityTipoTaxaImposto(value));
    dispatch(setModalCadastrarTipoTaxaImposto(true));
  };

  const closeModalCadastrar = () => {
    dispatch(setModalCadastrarTipoTaxaImposto(false));
  };

  const goDeletar = (value: TipoTaxaImpostoModel) => {
    dispatch(setEntityTipoTaxaImposto(value));
    dispatch(setModalDeletarTipoTaxaImposto(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarTipoTaxaImposto(false));
  };

  const onSearch = (value: string) => {
    dispatch(setBuscaTipoTaxaImposto(value));
    dispatch(buscarTipoTaxaImposto(value));
  };

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
    },
  ];

  const columns: ColumnsType<TipoTaxaImpostoModel> = [
    {
      title: "DENOMINAÇÃO",
      dataIndex: "denominacao",
      sorter: (a, b) => a.denominacao.localeCompare(b.denominacao),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      render: (_, record) => <AcoesComponent record={record} items={items} />,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical">
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              <Form.Item label="Pesquisar" name="pesquisar">
                <Search allowClear placeholder="Denominação" onSearch={onSearch} className="searchInput" enterButton style={{ width: 300 }} />
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="end">
              <ButtonComponent onClick={goCadastrar} />
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent data={tipoTaxaImpostoState.list} columns={columns} loading={tipoTaxaImpostoState.loading} />
      <Modal
        title={editar ? "EDITAR TIPO DE TAXA/IMPOSTO" : "NOVO TIPO DE TAXA/IMPOSTO"}
        centered
        width={450}
        open={tipoTaxaImpostoState.modalCadastrar}
        onCancel={closeModalCadastrar}
        footer={null}
        destroyOnHidden
      >
        <CadastroTipoTaxaImposto />
      </Modal>
      <Modal title={"REMOVER TIPO DE TAXA/IMPOSTO"} centered width={350} open={tipoTaxaImpostoState.modalDeletar} onCancel={closeModalDeletar} footer={null} destroyOnHidden>
        <MensagemModal
          text="Deseja remover o tipo de Taxa/Imposto?"
          action={deletarTipoTaxaImposto({ value: tipoTaxaImpostoState.entity.id, busca: tipoTaxaImpostoState.busca })}
          close={setModalDeletarTipoTaxaImposto(false)}
        />
      </Modal>
    </Flex>
  );
};

export default TipoTaxaImposto;
